
export enum AssetContractTypeEnum {
    OpenGlipERC1155 = "OpenGlipERC1155",
    GlipLiveERC721 = "GlipLiveERC721",
    GlipPassERC1155 = "GlipPassERC1155",
    ERC20 = "ERC20",
    ETH = "ETH",
    NONE = "NONE",
    ERC1155 = "ERC1155",
    ERC721 = "ERC721",
}


export interface ExchangeRate {
    currency?: string;
    rate?: number;
    symbol?: string;
    value?: number;
}




export interface ListOwnedNFTElement {
    token: TokenDataBase;
    quantity: string;
    exchange: ExchangeRate[];
}


export interface Media {
    type: string;
    value: string;
}


export enum NetworkEnum {
    // mumbai = "mumbai",
    matic = "matic",
    mainnet = "mainnet",
    bscMainnet = "bscMainnet",
    bora = "bora",
}



export enum TokenDataType {
    ETH = "ETH",
    ERC20 = "ERC20",
    ERC721 = "ERC721",
    ERC721_LAZY = "ERC721_LAZY",
    ERC1155 = "ERC1155",
    ERC1155_LAZY = "ERC1155_LAZY",
}


export interface CurrencyBase {
    id: string;
    name: string;
    symbol: string;
    image: string;

    chain: NetworkEnum;
    contractAddress: string;

    // https://docs.google.com/spreadsheets/d/1wTTuxXt8n9q7C4NDXqQpI3wpKu1_5bGVmP9Xz0XGSyU/edit#gid=0
    coingeckoId?: string;
    decimals: number;

    tokenMetadataId: string;
    global: boolean;
    walletIds: string[];

}



export interface TokenDataBase {
    id?: string;
    tokenGroupId?: string;
    type: TokenDataType;

    creatorId?: string;
    name: string;
    description: string;
    externalUri: string;
    imageUri: string;
    videoUri: string;
    supply: number;
    decimals: number;
    attributes: any;
    externalMetadataUri: string;

    reserveTokenDataId?: string,
    reserveTokenDataAmount?: number,

    assetContractId?: string;

    tokenId: string;   // Generate a token id as soon as this data is recieved

    lazyForm: any;        // With signature
    encodedFormBytes: any;

    minterWalletId?: string;
    minterPublicKey?: string;          // The one who sends the minting message to contract or authorizes the lazy form // required: true

    // Value set by some external service or hard set
    valueInUSD?: number;


}

export interface ContractBase {
    id?: string;
    name: string;
    description?: string;
    symbol: string,
    chain: NetworkEnum;
    image?: string;
    externalUrl?: string;
    type: AssetContractTypeEnum;
    media?: Media[];
    contractAddress: string;
    transactionHash?: string;
    confirmed?: boolean;
    deployer?: string;
    factory?: string;
    owner?: string;
    creatorId?: string;
    isExternal?: boolean;
    isGlobal?: boolean;
    registeredWalletIds?: string[];
}


export interface CurrencyWithExchanges extends CurrencyBase {
    exchange: ExchangeRate[];
}



export interface ItemMap<T> {
    [key: string]: T;
}



export interface TokenMetadata {
    contracts: ContractBase[];
    tokenMetadatas: TokenDataBase[];
    tokens: ListOwnedNFTElement[];
}

export interface TokenMetadataWithCurrencies extends TokenMetadata {
    currencies?: CurrencyBase[];
    currencyMap?: ItemMap<CurrencyWithExchanges>;
}


export interface IFetchTokensMetadata<T> {
    nfts: T;
    coins: T;
}

export interface WalletBalance {
    contracts: ItemMap<ContractBase>;
    tokens: ListOwnedNFTElement[];
    currencies: ItemMap<CurrencyWithExchanges>;
}
